'use client';

import { useTranslations } from 'next-intl';

export const OrSeparator = () => {
  const t = useTranslations();
  return (
    <div className="flex items-center my-4 w-full">
      <div className="flex-grow border-t text-(--color-text-primary)" />
      <span className="mx-4 text-sm text-(--color-text-primary) font-medium">
        {t('DIVIDER_OR')}
      </span>
      <div className="flex-grow border-t text-(--color-text-primary)" />
    </div>
  );
};
